import { render, staticRenderFns } from "./CopyToPhoneBlock.vue?vue&type=template&id=572180c4"
import script from "./CopyToPhoneBlock.vue?vue&type=script&lang=js"
export * from "./CopyToPhoneBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports